export const typesMap = {
  tag: "Tag",
  location: "Location",
  financialStage: "Financial stage",
  funding: "Funding",
  foundingYear: "Founding year",
  lastFundingDate: "Last funding date",
  lastFundingYear: "Last funding year",
  description: "Description",
  group: "Group"
};

export type ConditionType = keyof typeof typesMap;
export const operandsList = ["is", "is_not", "greater_than", "less_than", "includes", "do_not_includes"];
export type OperandType = "is" | "is_not" | "greater_than" | "less_than" | "includes" | "do_not_includes";

export type ConditionRowFilter = {
  id: string;
  type: ConditionType;
  operand: OperandType;
  isOr: boolean;
  value?: string;
  error?: string;
  filters?: ConditionRowFilter[];
};

export type ConditionRowFilterExtended = Omit<ConditionRowFilter, "type"> & {
  type: ConditionType | "staticTag";
};

type Option = {
  value: string;
  label: string;
};

export type ConditionRowOptions = Partial<Record<ConditionType, Option[]>>;
